import { format, isToday, isYesterday } from 'date-fns';
import { he, enUS } from 'date-fns/locale';

/** Shared by the employee ticket chat and the portal request thread (D-229). */
export const CHAT_AREA_BG = 'bg-surface-50';

export function formatMessageTime(dateStr: string): string {
  return format(new Date(dateStr), 'HH:mm', { locale: he });
}

export function formatDateSeparator(dateStr: string, t: (k: string) => string, lang: string): string {
  const d = new Date(dateStr);
  if (isToday(d)) return t('chat.today');
  if (isYesterday(d)) return t('chat.yesterday');
  // The date-fns pattern is locale data (Hebrew uses "d בMMMM", English "MMMM d").
  return format(d, t('chat.dateSeparatorFormat'), { locale: lang.startsWith('he') ? he : enUS });
}

export function shouldShowDateSeparator(current: string, previous: string | null): boolean {
  if (!previous) return true;
  return new Date(current).toDateString() !== new Date(previous).toDateString();
}

/** Bubble surface classes: own = tinted, other = white with border, tail corner on the sender side. */
export function bubbleSurface(own: boolean): string {
  return own
    ? 'bg-primary-50 text-surface-900 rounded-se-xs'
    : 'bg-surface-0 text-surface-900 border border-surface-200 rounded-ss-xs';
}
